import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Nombre del evento", -1)
const _hoisted_4 = { class: "form-group row" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Tipo", -1)
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Categoría", -1)
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Modalidad", -1)
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Fecha de inicio", -1)
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Fecha de término", -1)
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Región", -1)
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Lugar", -1)
const _hoisted_21 = { class: "form-group row" }
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Slug/url amigable", -1)
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = { class: "col-sm-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Año permitido", -1)
const _hoisted_27 = { class: "col-sm-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Buscar DNI", -1)
const _hoisted_29 = { class: "col-sm-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Inscripciones", -1)
const _hoisted_31 = { class: "col-sm-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Estado", -1)
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.gblDialog,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.gblDialog) = $event)),
    class: "bg-light",
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    top: "2vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-danger btn-sm text-hover-white me-2",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.gblDialog = false))
        }, " Cancelar "),
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.loader,
          class: "btn btn-primary btn-sm",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.gblAction=='new' ? 'Registrar' : 'Actualizar'), 1)
        ], 8, _hoisted_34)
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref: "ruleFormRef",
        model: _ctx.form,
        "status-icon": "",
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_form_item, { prop: "name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    onKeyup: _ctx.getUrl
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, { prop: "tipo" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.tipo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.tipo) = $event)),
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypes, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `t-${item.iddetails}`,
                          label: item.name,
                          value: item.iddetails
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_form_item, { prop: "level" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.level,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.level) = $event)),
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategorie, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `c-${item.iddetails}`,
                          label: item.name,
                          value: item.iddetails
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_form_item, { prop: "modality" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.modality,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.modality) = $event)),
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModality, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `d-${item.iddetails}`,
                          label: item.name,
                          value: item.iddetails
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_el_form_item, { prop: "startdate" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.form.startdate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.startdate) = $event)),
                    class: "w-100",
                    type: "date",
                    placeholder: "seleccione",
                    "value-format": "YYYY-MM-DD",
                    format: "DD/MM/YYYY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_el_form_item, { prop: "enddate" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.form.enddate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.enddate) = $event)),
                    class: "w-100",
                    type: "date",
                    placeholder: "seleccione",
                    "value-format": "YYYY-MM-DD",
                    format: "DD/MM/YYYY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_el_form_item, { prop: "idseat" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.idseat,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.idseat) = $event)),
                    filterable: "",
                    clearable: "",
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRegions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lr-${item.idregion}`,
                          label: item.name,
                          value: item.idregion
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_el_form_item, { prop: "place" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.place,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.place) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_el_form_item, { prop: "slug" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.slug,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.slug) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_el_form_item, {
                prop: "allowed_max",
                rules: [
                            { required: true, message: 'campo requerido' },
                            { type: 'number', message: 'Ingrese un número' },
                        ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.allowed_max,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.allowed_max) = $event)),
                    modelModifiers: { number: true },
                    maxlength: "4",
                    minlength: "4"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_el_form_item, { prop: "search_dni" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.search_dni,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.search_dni) = $event)),
                    size: "large",
                    "active-text": "SI",
                    "inactive-text": "NO"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_el_form_item, { prop: "register" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.register,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.register) = $event)),
                    size: "large",
                    "active-text": "SI",
                    "inactive-text": "NO"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_el_form_item, { prop: "mstatus" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.mstatus,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.mstatus) = $event)),
                    placeholder: "Seleccione"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `s-${item.iddetails}`,
                          label: item.name,
                          value: item.iddetails
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])), [
        [_directive_loading, _ctx.loader]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onOpened", "onClosed"]))
}